import { sliderAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(
  sliderAnatomy.keys,
);

const baseStyle = definePartsStyle({
  track: {
    bg: 'border.muted',
    borderRadius: 'full',
  },
  filledTrack: {
    bg: 'accent.default',
  },
  thumb: {
    bg: 'bg.input',
    borderWidth: '1px',
    borderColor: 'border.emphasized',
    transitionProperty: 'transform, box-shadow, background-color',
    transitionDuration: 'normal',
    _focusVisible: {
      boxShadow: '0 0 0 2px var(--chakra-colors-accent-default)',
    },
    _active: {
      transform: 'scale(1.05)',
    },
    _disabled: {
      bg: 'bg.disabled',
      borderColor: 'border.muted',
    },
  },
});

export const Slider = defineMultiStyleConfig({
  baseStyle,
});
